import React, { useEffect, useState, useContext } from 'react';
import { Table } from 'antd';
import * as Setting from '../../utils/AuthUtils';
import { byesCols } from '../../utils/DataUtils';
import { MeContext } from '../../context';
import { motion } from 'motion/react';

function ByesList(props) {
    const [hasRights, setHasRights] = useState({isAdmin: false, isReferral: false});
    const me = useContext(MeContext);

    useEffect(() => {
      const isAd = (me && me.payLoad ? me.payLoad.isAdmin : false)
      const isRef = Setting.isReferral(me && me.payLoad ? me.payLoad : {}); 
      setHasRights({isAdmin: isAd, isReferral: isRef});
      }, [me])
      
      return (
        <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} style={{ padding: '0 50px'}}>
        <h1>
            Byes
        </h1>
        <Table
            columns={byesCols} 
            dataSource={(props.byes && props.byes.payLoad? props.byes.payLoad : [])} 
            pagination={false} 
            loading={props.pending}/>
        </motion.div>
    );
}

export default ByesList;